import { render, staticRenderFns } from "./WsSearchBar.vue?vue&type=template&id=b3ffb3ca&"
import script from "./WsSearchBar.vue?vue&type=script&lang=js&"
export * from "./WsSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports